import weightReading from './weightReading.vue'
export default weightReading



// WEBPACK FOOTER //
// ./src/components/weightReading/index.js